import Banner from "molecules/banner";
import React from "react";

export default function EngageWithUs() {
  return (
    <>
      <Banner
        bannerImage="/EngageWithUs/banner-engage.jpg"
        mainHeading="Different voices, <br class='sm:hidden block'/> one vision"
        subHeading="Shaping an inclusive India with development entrepreneurship"
      />
    </>
  );
}
